import { ActionType } from "@sp-crm/core";
import { TertiarynavMenu, TertiarynavMenuItem } from "components/navigation/tertiarynav";
import React from "react";
import { useFeature, useIsAllowedInWholeTenant } from "store/selectors/hooks";

export const ManageIntegrationsNav: React.FC<unknown> = () => {
    const isTwilioEnabled = useFeature("twilioIntegration");
    const isWebhooksEnabled = useFeature("webhooks");
    const isPlacementEnabled = useFeature("placement");
    const isWellSkyEnabled = useFeature("wellSkyIntegration");
    const isAxisCareEnabled = useFeature("axisCareIntegration");
    const wholeTenantAccess = useIsAllowedInWholeTenant(ActionType.ManageIntegrations);

    return (
        <TertiarynavMenu>
            {wholeTenantAccess && (
                <TertiarynavMenuItem to="/settings/integrations/accounts">
                    Accounts
                </TertiarynavMenuItem>
            )}
            {isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/quickbooks">
                    QuickBooks
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/mailchimp">
                    Mailchimp
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/constant-contact">
                    Constant Contact
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isTwilioEnabled && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/twilio">
                    Twilio
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isWebhooksEnabled && isPlacementEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/webhooks">
                    Webhooks
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isWellSkyEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/wellsky-personal-care">
                    WellSky Personal Care
                </TertiarynavMenuItem>
            )}
            {wholeTenantAccess && isAxisCareEnabled && (
                <TertiarynavMenuItem to="/settings/integrations/axiscare">
                    AxisCare
                </TertiarynavMenuItem>
            )}
        </TertiarynavMenu>
    );
};
